export enum TypesSnackbars {
    SUCCESS = 'success',
    INFO = 'info',
}
